import { apiRequest } from './auth';

// API dla użytkowników
export const usersAPI = {
  // Pobierz wszystkich użytkowników
  getAll: async () => {
    return await apiRequest('/users');
  },

  // Pobierz użytkownika po ID
  getById: async (id) => {
    return await apiRequest(`/users/${id}`);
  },

  // Utwórz użytkownika
  create: async (userData) => {
    return await apiRequest('/users', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  },

  // Zaktualizuj użytkownika
  update: async (id, userData) => {
    return await apiRequest(`/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });
  },

  // Usuń użytkownika
  delete: async (id) => {
    return await apiRequest(`/users/${id}`, {
      method: 'DELETE',
    });
  },

  // Zmień hasło
  changePassword: async (id, password) => {
    return await apiRequest(`/users/${id}/change-password`, {
      method: 'POST',
      body: JSON.stringify({ password }),
    });
  }
};

export default usersAPI;



